import { useId, useState } from "react";
import { useAuth } from "@rekonas/auth";
import { authCacheScope } from "@rekonas/data-access";
import { AccountViewerPreferences, useViewerPreferences } from "@rekonas/signal-viewer";
import { Card, CardContent, CardHeader } from "@rekonas/ui";

import { AccountAllowances } from "../components/AccountUsage";
import { UsageHistory } from "../components/UsageHistory";
export { DailyUsage } from "../components/AccountUsage";

const ACCOUNT_TABS = ["Your account", "Usage today", "Usage history", "Viewer preferences"] as const;

export function AccountSettingsPage() {
  const { user } = useAuth();
  const id = useId();
  const [tab, setTab] = useState(0);
  const [values, setValues] = useViewerPreferences(authCacheScope());
  return <main className="operational-main account-main">
    <header className="account-page-heading"><h1>Account settings</h1><p>Manage your viewer preferences and review your account and AI usage.</p></header>
    <div className="account-tabs" role="tablist" aria-label="Account settings sections" onKeyDown={event => {
      const next = event.key === "ArrowRight" ? (tab + 1) % ACCOUNT_TABS.length
        : event.key === "ArrowLeft" ? (tab + ACCOUNT_TABS.length - 1) % ACCOUNT_TABS.length
          : event.key === "Home" ? 0 : event.key === "End" ? ACCOUNT_TABS.length - 1 : -1;
      if (next < 0) return;
      event.preventDefault(); setTab(next);
      event.currentTarget.querySelectorAll<HTMLButtonElement>('[role="tab"]')[next]?.focus();
    }}>
      {ACCOUNT_TABS.map((name, index) => <button key={name} id={`${id}-tab-${index}`} type="button" role="tab"
        aria-selected={tab === index} aria-controls={`${id}-panel-${index}`} tabIndex={tab === index ? 0 : -1}
        onClick={() => setTab(index)}>{name}</button>)}
    </div>
    <div className="account-grid">
      <section className="account-tab-panel" role="tabpanel" id={`${id}-panel-0`} aria-labelledby={`${id}-tab-0`} hidden={tab !== 0} tabIndex={0}>
      <Card><CardHeader><h2>Your account</h2></CardHeader><CardContent>
        <dl className="account-identity"><dt>Name</dt><dd>{String(user?.name || user?.username || "Not provided")}</dd>
          <dt>Email</dt><dd>{String(user?.email || "Not provided")}</dd></dl>
      </CardContent></Card>
      </section>
      <section className="account-tab-panel" role="tabpanel" id={`${id}-panel-1`} aria-labelledby={`${id}-tab-1`} hidden={tab !== 1} tabIndex={0}>
      <Card><CardHeader><h2>AI usage today</h2></CardHeader><CardContent>
        <AccountAllowances />
      </CardContent></Card>
      </section>
      <section className="account-tab-panel" role="tabpanel" id={`${id}-panel-2`} aria-labelledby={`${id}-tab-2`} hidden={tab !== 2} tabIndex={0}>
      <UsageHistory />
      </section>
      <section className="account-tab-panel" role="tabpanel" id={`${id}-panel-3`} aria-labelledby={`${id}-tab-3`} hidden={tab !== 3} tabIndex={0}>
      <Card className="account-preferences"><CardHeader><h2>Preferences</h2></CardHeader><CardContent>
        <AccountViewerPreferences key={authCacheScope()} preferences={values} setPreferences={setValues} />
      </CardContent></Card>
      </section>
    </div>
  </main>;
}
